import React from 'react';
import { Modal, Form, Input, Select, InputNumber, Space, Button, Divider, Row, Col } from 'antd';
import { CloudServerOutlined, GlobalOutlined } from '@ant-design/icons';

const { Option } = Select;

const AddEndpointModal = ({ visible, onCancel, onAdd, loading }) => {
  const [form] = Form.useForm();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      onAdd(values);
      form.resetFields();
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  return (
    <Modal
      title="Add New Endpoint"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      width={600}
      className="add-endpoint-modal"
    >
      <Form
        form={form}
        layout="vertical"
        className="add-endpoint-form"
      >
        {/* 基本信息 */}
        <div className="form-section">
          <h4>Basic Information</h4>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Endpoint Name"
                rules={[{ required: true, message: 'Please enter endpoint name' }]}
              >
                <Input 
                  placeholder="e.g. AWS-Singapore-1"
                  prefix={<CloudServerOutlined style={{ color: '#bfbfbf' }} />}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="type"
                label="Endpoint Type"
                rules={[{ required: true, message: 'Please select endpoint type' }]}
              >
                <Select placeholder="Select type">
                  <Option value="CDN">CDN</Option>
                  <Option value="Origin">Origin Server</Option>
                  <Option value="Load Balancer">Load Balancer</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </div>

        <Divider style={{ margin: '12px 0' }} />

        {/* 供應商設置 */}
        <div className="form-section">
          <h4>Provider Configuration</h4>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="provider"
                label="Cloud Provider"
                rules={[{ required: true, message: 'Please select provider' }]}
              >
                <Select placeholder="Select provider">
                  <Option value="AWS">Amazon Web Services</Option>
                  <Option value="GCP">Google Cloud Platform</Option>
                  <Option value="Azure">Microsoft Azure</Option>
                  <Option value="Custom">Custom</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="region"
                label="Region"
                rules={[{ required: true, message: 'Please select region' }]}
              >
                <Select placeholder="Select region">
                  <Option value="ap-southeast-1">Asia Pacific (Singapore)</Option>
                  <Option value="ap-northeast-1">Asia Pacific (Tokyo)</Option>
                  <Option value="us-west-1">US West (N. California)</Option>
                  <Option value="eu-central-1">Europe (Frankfurt)</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </div>

        <Divider style={{ margin: '12px 0' }} />

        {/* 流量設置 */}
        <div className="form-section">
          <h4>Traffic Settings</h4>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="initialWeight"
                label="Initial Traffic Weight (%)"
                rules={[
                  { required: true, message: 'Please enter initial traffic weight' },
                  { type: 'number', min: 0, max: 100, message: 'Weight must be between 0 and 100' }
                ]}
              >
                <InputNumber 
                  min={0} 
                  max={100}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="healthCheckPath"
                label="Health Check Path"
                rules={[{ required: true, message: 'Please enter health check path' }]}
              >
                <Input 
                  placeholder="/health"
                  prefix={<GlobalOutlined style={{ color: '#bfbfbf' }} />}
                />
              </Form.Item>
            </Col>
          </Row>
        </div>

        {/* 按鈕區域 */}
        <div className="form-actions">
          <Space size="middle" style={{ width: '100%', justifyContent: 'flex-end' }}>
            <Button onClick={onCancel}>
              Cancel
            </Button>
            <Button type="primary" onClick={handleSubmit} loading={loading}>
              Add Endpoint
            </Button>
          </Space>
        </div>
      </Form>
    </Modal>
  );
};

export default AddEndpointModal;
